var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplayed)?_c('iw-input-checkbox',{staticClass:"field",attrs:{"input-label":_vm.$t('has_internet'),"name":"has-internet"},model:{value:(_vm.hasInternet),callback:function ($$v) {_vm.hasInternet=$$v},expression:"hasInternet"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }